import { 
    apiBizGetTaskUnpaid
    } from "@/apis/api.js"; 

/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_task_unpaid_list: 'bizTaskUnpaidMgt/set_task_unpaid_list',
    set_task_total_page: 'bizTaskUnpaidMgt/set_task_total_page',
    set_task_payment_info: 'bizTaskUnpaidMgt/set_task_payment_info',
    set_wallet_balance: 'bizTaskUnpaidMgt/set_wallet_balance',
    set_filter_query: 'bizTaskUnpaidMgt/set_filter_query',
    set_filter_word: 'bizTaskUnpaidMgt/set_filter_word',
    set_filter_result_total: 'bizTaskUnpaidMgt/set_filter_result_total',
    set_filter_default: 'bizTaskUnpaidMgt/set_filter_default',
}

// count state 必須是 Object
const state = {
    taskUnpaidMgtList: [],
    paymentInfo: null,
    totalPage: 0,
    walletBalance: 0,
    filterQuery: {},
    filterTotal: 0,
    filterWord: '',
    isDefault: true,
    isLoading: false,
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_BIZ_TASK_UNPAID_MGT_LIST: (state) => {
        return state.taskUnpaidMgtList
    },
    GET_BIZ_TASK_PAYMENT_INFO: (state) => {
        return state.paymentInfo
    },
    GET_BIZ_TASK_UNPAID_MGT_TOTAL_PAGE: (state) => {
        return state.totalPage
    },
    GET_BIZ_TASK_UNPAID_MGT_FILTER_QUERY: (state) => {
        return state.filterQuery
    },
    GET_BIZ_TASK_UNPAID_MGT_FILTER_WORD: (state) => {
        return state.filterWord
    },
    GET_BIZ_TASK_UNPAID_MGT_FILTER_RESULT_TOTAL: (state) => {
        return state.filterTotal
    },
    GET_BIZ_TASK_UNPAID_MGT_FILTER_DEFAULT: (state) => {
        return state.isDefault
    },
    GET_BIZ_TASK_UNPAID_MGT_UNPAID_AMOUNG_TOTAL: (state) => {
        let total = 0

        for (let i = 0; i < state.taskUnpaidMgtList.length; i++) {
            const element = state.taskUnpaidMgtList[i];

            total += element.taskBonus
            
        }

        return total
    },
    GET_BIZ_TASK_UNPAID_MGT_WALLET_BALANCE: (state) => {
        return state.walletBalance
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    getBizTaskUnpaidMgtList ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_task_unpaid_list, '');
            apiBizGetTaskUnpaid(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    // console.log(res)
                    if(res.data.result.houseTaskVoList != undefined){
                        commit(types.set_task_unpaid_list, res.data.result.houseTaskVoList);
                        commit(types.set_task_total_page, res.data.result.totalPage);
                        commit(types.set_wallet_balance, res.data.result.balance.balance);
                    }
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
            
        })
    },
    setBizTaskUnpaidMgtPaymentInfo ( {commit} , data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_task_payment_info, data);
            resolve()
        })
    },
    setBizTaskUnpaidMgtFilterQuery ( {commit} , data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_query, data);
            resolve()
        })
    },
    setBizTaskUnpaidMgtFilterWord ( {commit} , data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_word, data);
            resolve()
        })
    },
    setBizTaskUnpaidMgtFilterResultTotal ( {commit} , data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_result_total, data);
            resolve()
        })
    },
    setBizTaskUnpaidMgtFilterDefault ( {commit} ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_default);
            resolve()
        })
    },
}

// mutations
const mutations = {
    [types.set_task_unpaid_list](state, data){
        if(data){
            data.map( item => {
                state.taskUnpaidMgtList.push(item) 
            })
        }else{
            state.taskUnpaidMgtList = []
        }
        
    },
    [types.set_task_payment_info](state, data){
        state.paymentInfo = data
    },
    [types.set_task_total_page](state, data){
        state.totalPage = data
    },
    [types.set_filter_result_total](state, data){
        state.filterTotal = data
    },
    [types.set_wallet_balance](state, data){
        state.walletBalance = data
    },
    [types.set_filter_word](state, data){
        state.filterWord = data
        state.isDefault = false
    },
    [types.set_filter_query](state, data){
        state.filterQuery = data
        state.isDefault = false
    },
    [types.set_filter_default](state){
        state.filterQuery = {}
        setTimeout(()=>{
            state.isDefault = true
        },100)
    },
    
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/bussiness/mgtCategory/taskMgt/taskUnpaidMgt.js